import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { localStorageGetItem } from "src/utils/storage-available";

import { useSettingsContext } from "src/components/settings";

import { allLangs, defaultLang } from "./config-lang";

// ----------------------------------------------------------------------

// Map browser ISO codes -> your app codes
const BROWSER_TO_APP_LANG: Record<string, string> = {
  sr: "srb",
  el: "gre",
  de: "ger",
  en: "en",
  fr: "fr",
  hu: "hu",
  bg: "bg",
};

function pickAppLangFromBrowser(allLangs: { value: string }[]) {
  if (typeof navigator === "undefined") return "";
  const candidates =
    (navigator.languages?.length
      ? navigator.languages
      : [navigator.language]) || [];
  const appValues = new Set(allLangs.map((l) => l.value));

  for (const raw of candidates) {
    const primary = (raw || "").toLowerCase().split("-")[0]; // e.g. sr-Latn-RS -> sr
    const mapped = BROWSER_TO_APP_LANG[primary] || primary;
    if (appValues.has(mapped)) return mapped;
  }
  return "";
}

export function useLocales() {
  const langStorage = localStorageGetItem("i18nextLng");
  const langFromStorage = allLangs.find((l) => l.value === langStorage) || null;

  const browserCode = langFromStorage ? "" : pickAppLangFromBrowser(allLangs);
  const langFromBrowser = allLangs.find((l) => l.value === browserCode) || null;

  const currentLang = langFromStorage || langFromBrowser || defaultLang;
  const initialSource = langFromStorage
    ? "storage"
    : langFromBrowser
    ? "browser"
    : "default";

  return { allLangs, currentLang, initialSource };
}

// export function useLocales() {
//   const langStorage = localStorageGetItem("i18nextLng");

//   const currentLang =
//     allLangs.find((lang) => lang.value === langStorage) || defaultLang;
//   return {
//     allLangs,
//     currentLang,
//   };
// }

// // ----------------------------------------------------------------------

export function useTranslate() {
  const { t, i18n, ready } = useTranslation();

  const settings = useSettingsContext();

  const onChangeLang = useCallback(
    (newlang: string) => {
      i18n.changeLanguage(newlang);
      settings.onChangeDirectionByLang(newlang);
    },
    [i18n, settings]
  );

  return {
    t,
    i18n,
    ready,
    onChangeLang,
  };
}
